import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setBreadcrumbItems } from "../../store/actions";

const { Text } = Typography;

const EditAddress = ({ setBreadcrumbItems }) => {
  const [addressDetails, setAddressDetails] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");

  const { addressId } = useParams();
  const navigate = useNavigate();
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const breadcrumbItems = [
    { title: "Address", link: "#" },
    { title: "Edit Address", link: "#" },
  ];

  useEffect(() => {
    setBreadcrumbItems("Edit Address", breadcrumbItems);
    fetchAddressDetails();
  }, [setBreadcrumbItems]);

  const fetchAddressDetails = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASEURL}/address/${addressId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "*/*",
        },
      });

      const { addressDetails, state, city } = res.data;
      setAddressDetails(addressDetails);
      setState(state);
      setCity(city);
    } catch (error) {
      console.error(error);
      message.error("Failed to load address details");
    }
  };

  const handleUpdate = async () => {
    if (!addressDetails.trim() || !state || !city) {
      message.warning("Please enter all required fields");
      return;
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASEURL}/address/${addressId}`,
        {
          addressDetails,
          city,
          state,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "*/*",
          },
        }
      );
      message.success("Address updated successfully");
      navigate("/address-listing");
    } catch (error) {
      console.error(error);
      message.error("Failed to update address");
    }
  };

  return (
    <div className="p-4">
      <Card style={{ marginTop: 20 }} title="Edit Address">
        <Row>
          <Col span={24}>
            <Text strong>Address</Text>
            <Input
              placeholder="Enter Address"
              value={addressDetails}
              onChange={(e) => setAddressDetails(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Text strong>State</Text>
            <Input
              placeholder="Enter State"
              value={state}
              onChange={(e) => setState(e.target.value)}
              style={{ width: "100%", marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Text strong>City / Village</Text>
            <Input
              placeholder="Enter City or Village Name"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              style={{ width: "100%", marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={handleUpdate}
              style={{ backgroundColor: PRIMARY_RED, borderColor: PRIMARY_RED }}
            >
              Edit Address
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/address-listing")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(EditAddress);
